import { render } from "./VerbaleSopralluogo.vue?vue&type=template&id=68240958&scoped=true"
import script from "./VerbaleSopralluogo.vue?vue&type=script&lang=js"
export * from "./VerbaleSopralluogo.vue?vue&type=script&lang=js"

import "./VerbaleSopralluogo.vue?vue&type=style&index=0&id=68240958&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68240958"]])

export default __exports__